/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_EventInputs */

const th_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดรายการแข่งขัน…`)
};

const en_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading event…`)
};

const ja_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会を読み込んでいます…`)
};

const zh_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载赛事…`)
};

const es_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando evento…`)
};

const pt_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando evento…`)
};

const id_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat acara…`)
};

const fr_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de l’événement…`)
};

const tl_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang event…`)
};

const vi_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải sự kiện…`)
};

const ko_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트를 불러오는 중…`)
};

const de_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event wird geladen…`)
};

const ru_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем событие…`)
};

const tr_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik yükleniyor…`)
};

const it_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento evento…`)
};

const pl_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie wydarzenia…`)
};

const uk_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо подію…`)
};

const hi_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन लोड हो रहा है…`)
};

const ar_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل الفعالية…`)
};

const ms_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat acara…`)
};

const bn_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন লোড হচ্ছে…`)
};

const zh_tw2_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入賽事…`)
};

const zh_hk2_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入賽事…`)
};

const ur_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ لوڈ ہو رہا ہے…`)
};

const fa_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری رویداد…`)
};

const sw_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia tukio…`)
};

const nl_loading_event = /** @type {(inputs: Loading_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement laden…`)
};

/**
* | output |
* | --- |
* | "Loading event…" |
*
* @param {Loading_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_event = /** @type {((inputs?: Loading_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_event(inputs)
	if (locale === "ja") return ja_loading_event(inputs)
	if (locale === "zh") return zh_loading_event(inputs)
	if (locale === "es") return es_loading_event(inputs)
	if (locale === "pt") return pt_loading_event(inputs)
	if (locale === "id") return id_loading_event(inputs)
	if (locale === "fr") return fr_loading_event(inputs)
	if (locale === "tl") return tl_loading_event(inputs)
	if (locale === "vi") return vi_loading_event(inputs)
	if (locale === "ko") return ko_loading_event(inputs)
	if (locale === "de") return de_loading_event(inputs)
	if (locale === "ru") return ru_loading_event(inputs)
	if (locale === "tr") return tr_loading_event(inputs)
	if (locale === "it") return it_loading_event(inputs)
	if (locale === "pl") return pl_loading_event(inputs)
	if (locale === "uk") return uk_loading_event(inputs)
	if (locale === "hi") return hi_loading_event(inputs)
	if (locale === "ar") return ar_loading_event(inputs)
	if (locale === "ms") return ms_loading_event(inputs)
	if (locale === "bn") return bn_loading_event(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_event(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_event(inputs)
	if (locale === "ur") return ur_loading_event(inputs)
	if (locale === "fa") return fa_loading_event(inputs)
	if (locale === "sw") return sw_loading_event(inputs)
	if (locale === "nl") return nl_loading_event(inputs)
	return en_loading_event(inputs)
});